import axiosInstance from './AxiosInstance';

const CustomerService = {
    // Create new customer
    createCustomer: async (customerData) => {
        try {
            const response = await axiosInstance.post('/customers', customerData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to create customer";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Update existing customer
    updateCustomer: async (customerId, customerData) => {
        try {
            const response = await axiosInstance.put(`/customers/${customerId}`, customerData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to update customer";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Get single customer
    getCustomer: async (customerId) => {
        try {
            const response = await axiosInstance.get(`/customers/${customerId}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch customer";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // List all customers with pagination and filters
    listCustomers: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            
            if (params.search) queryParams.append('search', params.search);
            if (params.status) queryParams.append('status', params.status);
            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            
            const queryString = queryParams.toString();
            const url = queryString 
                ? `/customers?${queryString}` 
                : '/customers';
            
            console.log('🌐 CustomerService.listCustomers - Calling URL:', url);
            const response = await axiosInstance.get(url);
            console.log('✅ CustomerService.listCustomers - Response:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ CustomerService.listCustomers - Error:', error);
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch customers";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Delete/Deactivate customer
    deleteCustomer: async (customerId) => {
        try {
            const response = await axiosInstance.delete(`/customers/${customerId}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to delete customer";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Search customers with advanced filters
    searchCustomers: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            
            if (params.search) queryParams.append('search', params.search);
            if (params.status) queryParams.append('status', params.status);
            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            
            const queryString = queryParams.toString();
            const url = queryString 
                ? `/customers?${queryString}` 
                : '/customers';
            
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to search customers";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    }
};

export default CustomerService;
